export interface ChatbotSuggestion {
    id: number;
    centerId: string;
    intentCode: string;
    prompts: string;
    rank: number;
    intentLanguage:string;
}

export interface ChatSuggestionState{
    inputValue: any;
    showSuggestion?:boolean;
    chatbotSuggestion?: ChatbotSuggestion[];
    filterSuggestion?: ChatbotSuggestion[];
    clearInput: boolean;
    showSuggestinFlag?: boolean;
}

export const initialChatSuggestionState: ChatSuggestionState = {
    showSuggestion: false,
    chatbotSuggestion: [],
    filterSuggestion: [],
    inputValue: "",
    clearInput: false,
    showSuggestinFlag: false
};

export interface ReqSuggestionHit {
    prompts?: string,
}